interface OnboardingProps {
  onComplete: () => void
}

export default function Onboarding({ onComplete }: OnboardingProps) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md glass-card rounded-3xl p-8 relative overflow-hidden">
        {/* Background blobs for depth */}
        <div className="absolute -top-20 -left-20 w-40 h-40 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-purple-500/20 rounded-full blur-3xl pointer-events-none"></div>

        <div className="relative z-10 text-center mb-10">
          <div className="w-24 h-24 mx-auto mb-6 rounded-2xl overflow-hidden border-2 border-white/10 shadow-neon">
            <img src="/icon.png" alt="BaseVibe" className="w-full h-full object-cover" />
          </div>

          <h2 className="text-3xl font-bold mb-2 text-white">
            BaseVibe
          </h2>
          <p className="text-xl font-light text-cyan-400 mb-6">
            What's the vibe?
          </p>

          <div className="space-y-4 text-sm text-gray-300">
            <p>
              Share your sentiment on the crypto market daily.
            </p>
            <p className="glass-card inline-block px-4 py-2 rounded-full border-blue-500/30 text-blue-200">
              🔥 Build your streak
            </p>
          </div>
        </div>

        <button
          onClick={onComplete}
          className="relative w-full px-6 py-4 rounded-xl font-bold text-white text-lg transition-transform hover:scale-[1.02] active:scale-[0.98] group overflow-hidden"
        >
          {/* Button Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-blue-500 to-purple-600 opacity-90 group-hover:opacity-100 transition-opacity"></div>

          {/* Button Content */}
          <span className="relative flex items-center justify-center gap-2">
            Get Started <span className="text-xl group-hover:translate-x-1 transition-transform">🚀</span>
          </span>
        </button>
      </div>
    </div>
  )
}

